import { useSyncExternalStore } from 'react';
import { Input } from './Input';
import { captureStore, PlayerAccessRights } from './store';
import { CaptureUi } from './CaptureUi';

interface InputCaptureProps {
  showUi?: boolean;
  skipGamepad?: boolean;
  /**
   * Explicit access rights (recommended for new code).
   * If provided, these take precedence over the global captureStore.
   * If not provided, falls back to captureStore for backwards compatibility.
   */
  access?: PlayerAccessRights;
}

export const InputCapture = (props: InputCaptureProps) => {
  const storeAccess = useSyncExternalStore(captureStore.subscribeAccess, captureStore.getAccess);
  const access = props.access ?? storeAccess;

  const { showUi = false, skipGamepad = false } = props;

  return (
    <>
      <Input {...access} skipGamepad={skipGamepad} />
      {showUi ? <CaptureUi /> : null}
    </>
  );
};
